const truncate = (text, max = 25) => {
  if (!text) return "";
  return text.length > max ? text.slice(0, max - 3) + "..." : text;
};

export default truncate;
